import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.http.options.root = process.env.API_URL

Vue.http.interceptor.before = (req, next) => {
  if (!req.headers.map.Authorization) {
    req.headers.set('Authorization', localStorage.getItem('token'))
  }
  next()
}



// WEBPACK FOOTER //
// ./src/http.js